import {
    AfterContentInit, booleanAttribute,
    Component,
    ContentChild,
    EventEmitter,
    Input,
    Output,
    ViewEncapsulation,
} from '@angular/core';
import {
    AbstractControl,
    FormArrayName,
    FormControlName,
    NgModel,
} from '@angular/forms';
import {DeprecatedSharedUtilsModule} from '../../deprecated-shared-utils-module';

@Component({
    selector: 'app-material-input',
    templateUrl: './material-input.component.html',
    styleUrls: [
        './styles/base-ng-select.scss',
        './styles/base.scss',
        './styles/placeholder-text.scss',
    ],
    encapsulation: ViewEncapsulation.None,
    imports: [
        DeprecatedSharedUtilsModule,
    ]
})
export class MaterialInputComponent implements AfterContentInit {
    input: NgModel | AbstractControl | FormControlName | FormArrayName;
    validate: boolean;

    @Input() label: string;
    @Input() helperText = '';
    @Input() kind: 'input-text' | 'placeholder-text' = 'input-text';
    @Input() inline: boolean;
    @Input() prefix: string;
    @Input() suffix: string;
    @Input() smallIcon: boolean;
    @Input() smallErrorText: boolean;
    @Input() patternErrorMsg;
    @Input() groupString = '';
    @Input() icon: string;
    @Input({transform: booleanAttribute}) required = false;
    @Output() onIconClick = new EventEmitter<MouseEvent>();

    @ContentChild(NgModel) model: NgModel;
    @ContentChild(FormControlName) control: FormControlName;
    @ContentChild(FormArrayName) array: FormArrayName;

    constructor() {}

    ngAfterContentInit() {
        this.input = this.model || this.control || this.array;

        if (this.input instanceof FormControlName) {
            (<HTMLInputElement>(
                (<any>this.input.valueAccessor)._elementRef?.nativeElement
            ))?.setAttribute('placeholder', this.label);
        }
    }

    get errored() {
        return (this.hasError() || this.validate) && this.getError();
    }

    hasError() {
        return (
            this.input?.invalid && (this.input?.dirty || this.input?.touched)
        );
    }

    iconClick() {
        this.onIconClick.emit(this.input?.value);
    }

    getError() {
        if (!this.input) {
            return;
        }

        // REQUIRED
        if (this.input.hasError('required')) {
            return this.inline ? '✱' : 'Campo obrigatório';
        } else if (this.input.hasError('minlength')) {
            if (this.smallErrorText) {
                return (
                    'Minimo de ' +
                    this.input.errors['minlength'].requiredLength +
                    ' caract.'
                );
            } else {
                return (
                    'Informe um minimo de ' +
                    this.input.errors['minlength'].requiredLength +
                    ' caracteres'
                );
            }
        } else if (this.input.hasError('maxlength')) {
            if (this.smallErrorText) {
                return (
                    'Máximo de ' +
                    this.input.errors['maxlength'].requiredLength +
                    ' caract.'
                );
            } else {
                return (
                    'Informe um máximo de ' +
                    this.input.errors['maxlength'].requiredLength +
                    ' caracteres'
                );
            }
        } else if (this.input.hasError('email')) {
            return 'Informe um email válido';
        } else if (
            this.input.hasError('pattern') ||
            (this.input.hasError('mask') && this.patternErrorMsg)
        ) {
            return this.patternErrorMsg ?? 'Padrão inválido';
        } else if (this.input.hasError('minDate')) {
            return 'Data mínima: ' + this.input.errors['minDate'];
        } else if (this.input.hasError('maxDate')) {
            return 'Data máxima: ' + this.input.errors['maxDate'];
        } else if (this.input.hasError('min')) {
            return (
                'O valor deve ser maior ou igual a ' + this.input.errors['min'].min
            );
        } else if (this.input.hasError('max')) {
            return (
                'O valor deve ser menor ou igual a ' + this.input.errors['max'].max
            );
        } else if (this.input.hasError('mask')) {
            return (
                'Valor inválido - Ex.: ' + this.input.errors['mask'].requiredMask
            );
        } else if (this.input.hasError('cpfInvalid')) {
            return 'CPF inválido';
        } else if (this.input.hasError('cpfJaExiste')) {
            return 'CPF já cadastrado';
        } else if (this.input.hasError('cnpjCpfInvalid')) {
            return 'CNPJ/CPF inválido';
        } else if (this.input.hasError('cnpjJaExiste')) {
            return 'CNPJ já cadastrado';
        } else if (this.input.hasError('veiculoJaExiste')) {
            return 'Veículo já cadastrado';
        } else if (this.input.hasError('cnhJaExiste')) {
            return 'CNH já cadastrada';
        } else if (this.input.hasError('posteriorCredenciamento')) {
           return 'Data de emissão inválida';
        } else if (this.input.hasError('dateNotFuture')) {
            return 'A data não pode ser posterior a data atual';
        } else if (this.input.hasError('hourNotFuture')) {
            return 'O horário não pode ser posterior ao horário atual';
        } else if (this.input.hasError('regulamentacaoJaExiste')) {
            return 'Uma regulamentação com esse ano e número já existe';
        } else if (this.input.hasError('emailJaExiste')) {
            return 'Email já cadastrado';
        } else if (this.input.hasError('minMultiselectSelections')) {
           return `Necessário no mínimo ${this.input.errors['minMultiselectSelections'].length}
           ${this.input.errors['minMultiselectSelections'].length > 1 ? 'seleções' : 'seleção'}!`;
        } else if (this.input.errors) {
            return 'Campo inválido';
        }
    }

    markErrors() {
        this.validate = true;
    }

    markOffErrors() {
        this.validate = false;
    }
}
